import { useTranslation } from 'helpers/hooks/useTranslation'
import React from 'react'
import styled from 'styled-components'
import { bordersColor } from 'uiComponents/constants/colors'
import { fwBold } from 'uiComponents/constants/typography'

export const LiveShowBanner: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Wrapper>
      <AnimatedDot />
      <span>{t('Jetzt live')}</span>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  text-transform: uppercase;
  ${fwBold}
  background: #f9ff00;
  border-bottom: 1px solid ${bordersColor};
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.08),
    0 -10px 15px 0 rgba(0, 0, 0, 0.04);
`

const AnimatedDot = styled.div`
  border-radius: 50%;
  margin: 10px;
  height: 10px;
  width: 10px;
  transform: scale(1);
  animation: pulse-black 2s infinite;
  background: rgba(255, 82, 82, 1);
  box-shadow: 0 0 0 0 rgba(255, 82, 82, 1);
  animation: pulse 2s infinite;

  @keyframes pulse {
    0% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(255, 82, 82, 0.7);
    }

    70% {
      transform: scale(1);
      box-shadow: 0 0 0 10px rgba(255, 82, 82, 0);
    }

    100% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(255, 82, 82, 0);
    }
  }
`
